import { getCookie } from '.'

function submitCheckoutForm(oFormElement, orderNo)
{
  const cookie = getCookie('_jwt')
  const action = oFormElement.getAttribute("action")
  oFormElement.action = process.env.VUE_APP_VUE_SERVICE_HOST + '/api/checkout' + '?jwt=' + cookie + '&order_no=' + orderNo
  oFormElement.submit()
}
window.submitCheckoutForm = submitCheckoutForm